var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.473,
    height: 38.473,
    viewBox: "0 0 38.473 38.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M37.346,12.173H20.288V6.763h1.5v2.63a1.127,1.127,0,1,0,2.254,0V5.636a1.127,1.127,0,0,0-1.127-1.127h-2.63V2.63A2.633,2.633,0,0,0,17.658,0h-1.5a2.633,2.633,0,0,0-2.63,2.63v9.543H11.158A5.636,5.636,0,0,0,0,13.3V32.837a5.642,5.642,0,0,0,5.636,5.636H32.687a1.127,1.127,0,0,0,1.127-1.127V33.964h3.532a1.127,1.127,0,0,0,1.127-1.127V13.3A1.127,1.127,0,0,0,37.346,12.173ZM15.78,2.63a.376.376,0,0,1,.376-.376h1.5a.376.376,0,0,1,.376.376V4.509H15.78Zm0,4.133h2.254v11.8A10.211,10.211,0,0,1,16.907,23.2,10.211,10.211,0,0,1,15.78,18.56ZM2.254,13.3a3.381,3.381,0,0,1,6.763,0V28.332a5.623,5.623,0,0,0-6.763,0ZM31.56,36.218H5.636a3.381,3.381,0,1,1,3.381-3.381,1.127,1.127,0,0,0,1.127,1.127H31.56Zm4.659-4.509H11.271V14.427h2.254V18.56a12.482,12.482,0,0,0,2.254,7.127v1.138a1.127,1.127,0,0,0,2.254,0V25.687a12.482,12.482,0,0,0,2.254-7.127V14.427h15.93Z",
    fill: "#0176c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M301.127,224.254h9.017a1.127,1.127,0,1,0,0-2.254h-9.017a1.127,1.127,0,1,0,0,2.254Z",
    transform: "translate(-277.457 -205.318)",
    fill: "#0176c0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M301.127,284.254h9.017a1.127,1.127,0,1,0,0-2.254h-9.017a1.127,1.127,0,1,0,0,2.254Z",
    transform: "translate(-277.457 -260.81)",
    fill: "#0176c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M365.636,362h-4.509a1.127,1.127,0,1,0,0,2.254h4.509a1.127,1.127,0,0,0,0-2.254Z",
    transform: "translate(-332.949 -334.799)",
    fill: "#0176c0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic-check.35cfcbcd.svg";
export { ForwardRef as ReactComponent };